import { FC, PropsWithChildren, useEffect, useRef } from 'react'
import { createPortal } from 'react-dom'

type Props = {
  className?: string
  to?: string
}

const Portal: FC<PropsWithChildren<Props>> = ({ to, children, className }) => {
  const container = useRef<HTMLDivElement>(document.createElement('div'))

  useEffect(() => {
    const copyContainer = container.current
    const selectedTarget = to ? document.querySelector(to) : null
    const target = selectedTarget ? selectedTarget : document.body

    if (className) {
      copyContainer.classList.add(className)
    }

    target.appendChild(copyContainer)
    return () => {
      target.removeChild(copyContainer)
    }
  }, [className, to])

  return createPortal(children, container.current)
}

export { Portal }
